<script setup lang="ts">
  import PlaneLoader from '@/components/ui/PlaneLoader.vue'
  import { useSherpaWidget } from '@/composables/widgets/sherpa/useSherpa'
  import type { TPlacement } from '@/components/widgets/types'

  const props = withDefaults(
    defineProps<{
      placement?: TPlacement
    }>(),
    {
      placement: 'homePage'
    }
  )
  const WIDGET_SELECTOR = 'sherpa-map-widget'

  useSherpaWidget({
    widgetConfig: {
      features: {
        showFilters: true,
        showMapLegend: true
      },
      placement: props.placement
    },
    widgetSelector: WIDGET_SELECTOR,
    widgetType: 'map'
  })
</script>

<template>
  <div :id="WIDGET_SELECTOR">
    <div class="flex h-40 w-full items-center justify-center">
      <PlaneLoader />
    </div>
  </div>
</template>
